import React, { useEffect, useState } from "react";
import {
  ApiDelete,
  ApiGet,
  ApiPost,
  ApiPut,
} from "../../../helpers/API/ApiData";
import DataTable, { defaultThemes } from "react-data-table-component";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import { Button, Dropdown } from "react-bootstrap";
import { getUserInfo } from "../../../utils/user.util";
import { Modal } from "react-bootstrap";
import Dialog from "@material-ui/core/Dialog";
import List from "@material-ui/core/List";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Coupen.scss";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Coupen = () => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    setSubmitValue(false);
    setUpdateProduct(true);
    setImage("");
    setDesc("");
    setTitle("");
  };

  const handleClose1 = () => {
    setOpen(false);
  };

  const [coupon, setCoupon] = useState({
    couponName: "",
    discountType: "percent_off",
    discountValue: 0,
    duration: "once",
    durationInMonths: 1,
    maxRedemptions: "",
    percent_off:0,
    redeemBy: "",
  });
  

  const [loading, setLoading] = useState(false);

  const [allProduct, setAllProduct] = useState();
  const [dataChange, setDataChange] = useState([]);
  const [pid, setPid] = useState();
  const [size, setSize] = useState();
  const [size1, setSize1] = useState([]);
  const [price, setPrice] = useState();
  const [type, setType] = useState();
  const [title, setTitle] = useState();
  const [image, setImage] = useState("");
  const [desc, setDesc] = useState();
  const [updateProduct, setUpdateProduct] = useState(false);
  const [submitValue, setSubmitValue] = useState(false);
  const [errors, setErrors] = useState({});
  const [loaderHas, setLoaderHas] = useState(false);
  const [OpenImages, setOpenImages] = useState();
  // const [errors] = useState([]);
  let userInfo = getUserInfo();

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = (id) => {
    setShow(true);
    setPid(id);
  };

  useEffect(() => {
    getProductData();
  }, [dataChange]);

  const formValidator = () => {
    let isValid = true;
  
    setErrors({}); // Clear previous errors
  
    if (!coupon.couponName?.trim()) {
      setErrors((cv) => ({ ...cv, couponName: "Please enter a coupon code" }));
      isValid = false;
    }
  
    if (!coupon.discountValue || Number(coupon.discountValue) <= 0) {
      setErrors((cv) => ({ ...cv, discountValue: "Discount value must be greater than 0" }));
      isValid = false;
    }
  
    const validDurations = ["once", "repeating", "forever"];
    if (!coupon.duration || !validDurations.includes(coupon.duration)) {
      setErrors((cv) => ({ ...cv, duration: "Please select a valid duration" }));
      isValid = false;
    }
  
    if (
      coupon.duration === "repeating" &&
      (!coupon.durationInMonths || Number(coupon.durationInMonths) <= 0)
    ) {
      setErrors((cv) => ({
        ...cv,
        durationInMonths: "Please enter a valid number of months",
      }));
      isValid = false;
    }
  
    if (
      coupon.maxRedemptions &&
      (isNaN(coupon.maxRedemptions) || Number(coupon.maxRedemptions) <= 0)
    ) {
      setErrors((cv) => ({
        ...cv,
        maxRedemptions: "Max redemptions must be a number greater than 0",
      }));
      isValid = false;
    }
  
    // Optional: validate redeemBy as a valid date
    if (coupon.redeemBy && isNaN(Date.parse(coupon.redeemBy))) {
      setErrors((cv) => ({
        ...cv,
        redeemBy: "Please enter a valid redeem-by date",
      }));
      isValid = false;
    }
  
    return isValid;
  };
  
  

  const getProductData = async () => {
    await ApiGet("webhook/get-coupon")
      .then((res) => {
        console.log("vaidhab---------------------", res.data.payload);
        setAllProduct(res.data.payload?.coupons        );
        setUserReport(res.data.payload?.coupons);
        // setFilteredReport(res.data.payload?.coupons);

      const stripeCoupons = res.data.payload?.coupons;

    const formatted = stripeCoupons.map((coupon) => ({
        couponDescription: coupon.metadata.name || `Coupon ${coupon.id}`,
        discountType: coupon.percent_off ? 'Percent' : 'Amount',
        discountValue: coupon.percent_off || coupon.amount_off || 'N/A',
        duration: coupon.duration == "forever" ? "sponsored" : coupon.duration,
        durationInMonths: coupon.duration_in_months || 'N/A',
        maxRedemptions: coupon.max_redemptions || 'Unlimited',
        redeemBy: coupon.redeem_by
          ? new Date(coupon.redeem_by * 1000).toLocaleDateString()
          : 'No Expiry',
        updatedAt: coupon.created * 1000,
        _id: coupon.id,
      }));
  
      setFilteredReport(formatted);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };


  console.log("couponcouponcoupon",coupon)
  const handleDeleteProduct = async () => {
    // const data = {
    //   id: id,
    // };

    setLoaderHas(true);
    await ApiDelete(`webhook/delete-Coupon/${pid}`)
      .then((res) => {
        getProductData()
        setLoaderHas(false);
        handleClose();
        // setDataChange([...dataChange, "Music delete"]);
        //console.log(res.data.data);
      })
      .catch((err) => {
        setLoaderHas(false);
        console.log("err");
      });
  };


  console.log("couponcoupon",coupon)
  const submitProduct = async () => {
    if (!formValidator()) {
      console.log("ERROR PUT", errors);
      return;
    }
    setLoading(true);
  







    await ApiPost("webhook/create-coupon",coupon)
      .then((res) => {
        setOpen(false);
        setUpdateProduct(false);
        setDataChange([...dataChange, "Product Added"]);

        setLoading(false);
        //console.log(res);
        setSize();
        setPrice();
        setType();
        setTitle();
        setImage();
        toast.success("Legend Add successfully");
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
        console.log(err);
      });
  };

  const handleForUpdateProduct = async (id) => {
    setOpen(true);
    setPid(id);
    setSubmitValue(true);

    await ApiGet(`legend/id=${id}`)
      .then((res) => {
        //console.log(res.data.data);
        //setAllMusic(res.data.data);
        setTitle(res.data.data.title);
        setDesc(res.data.data.description);
        setPrice(res.data.data.price);
        setSize1(res.data.data.size);
        setType(res.data.data.type);
        setOpenImages(res.data.data.legendsIcon);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getNewDate = (date) => {
    var d = new Date(date);
    var month = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var newDate = `${month[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
    return newDate;
  };

  const handleUpdateProduct = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("legendsName", title);
    formData.append("profileImage", image);
    formData.append("legendsDescription", desc);

    // const data = {
    //   legendsName: title,
    //   legendsIcon: image,
    //   legendsDescription: desc,
    // };

    await ApiPut(`legend/id=${pid}`, formData, {
      "Content-Type": "multipart/form-data",
    })
      .then((res) => {
        setOpen(false);
        setUpdateProduct(false);
        setDataChange([...dataChange, "Music Updated"]);
        setLoading(false);

        //console.log(res);
        setTitle();
        setDesc();
        setPrice();
        setSize1();
        setType();
        toast.success("legend Update successfully!");
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
        console.log(err);
      });
  };
  let i = 0;
  const columns = [
    {
      name: "S.No.",
      cell: (row, index) => index + 1,
      width: "80px",
    },
    {
      name: "Coupon Name",
      selector: "couponDescription",
      wrap: true,
      sortable: true,
    },
    {
      name: "Discount Type",
      selector: "discountType",
      sortable: true,
    },
    {
      name: "Discount Value",
      selector: "discountValue",
      sortable: true,
    },
    {
      name: "Duration",
      selector: "duration",
      sortable: true,
    },
    {
      name: "Duration in Months",
      selector: "durationInMonths",
      sortable: true,
    },
    // {
    //   name: "Max Redemptions",
    //   selector: "maxRedemptions",
    //   sortable: true,
    // },
    {
      name: "Update date",
      cell: (row) => {
        return <>{getNewDate(row.updatedAt)}</>;
      },
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => {
        return (
          <>
            <div className="d-flex justify-content-between">
              <div
                className="cursor-pointer mr-3"
                onClick={() => {
                  handleShow(row._id);
                }}
              >
                <DeleteIcon />
              </div>
              {/* <div
                className="cursor-pointer"
                onClick={() => {
                  setUpdateProduct(true);
  
                }}
              >
                <CreateIcon />
              </div> */}
            </div>
          </>
        );
      },
      sortable: true,
    },
  ];
  
  //* Table Style
  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: defaultThemes.default.divider.default,
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
    cells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
  };

  const handleSize = () => {
    setSize("");
    console.log(size);
    setSize1([...size1, size]);
  };
  console.log(size1);

  const [userReport, setUserReport] = useState();
  const [filteredReport, setFilteredReport] = useState();

  const handleSearch = (e) => {
    console.log("eeeee", e.target.value);
    var value = e.target.value.toLowerCase();
    setFilteredReport(() =>
      userReport.filter(
        (item) =>
          item?.legendsDescription?.toLowerCase().includes(value) ||
          item?.legendsName?.toLowerCase().includes(value)
        // item?.phone?.toLowerCase().includes(value)
      )
    );
  };

  console.log('DATAAAAAA', filteredReport, submitValue);

  return (
    <>
      <ToastContainer />
      <div>
        {/*  */}
        <div className="card p-1">
          <div className="p-2">
            <div className="row mb-4 pr-3">
              <div className="col d-flex justify-content-between">
                <h2 className="pl-3 pt-2">All Coupons</h2>
              </div>
              <div className="col">
                <div>
                  <input
                    type="text"
                    className={`form-control form-control-lg form-control-solid `}
                    name="title"
                    placeholder="Search Legends"
                    onChange={(e) => handleSearch(e)}
                  />
                </div>
              </div>
              <div className="cus-medium-button-style button-height">
                <button
                  className="btn btnColor"
                  onClick={() => {
                    handleClickOpen();
                  }}
                >
                  Add Coupons
                </button>
              </div>
            </div>
          </div>
          <DataTable
            columns={columns}
            data={filteredReport}
            customStyles={customStyles}
            pagination
            style={{
              marginTop: "-3rem",
            }}
          />
        </div>
        {/*  */}
      </div>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="text-danger">Alert!</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure want to delete Coupen?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancle
          </Button>
          <Button variant="danger" disabled={loaderHas} onClick={() => handleDeleteProduct()}>
            Delete
            {loaderHas && (
                <span className="mx-3 spinner spinner-white"></span>
              )}
          </Button>
        </Modal.Footer>
      </Modal>

      <Dialog
        fullScreen
        open={open}
        onClose={handleClose1}
        TransitionComponent={Transition}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose1}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>

        <List>
  {updateProduct && updateProduct === true ? (
    <div className="form ml-30">

      {/* Description */}
      <div className="form-group row">
        <div className="col-lg-9 col-xl-6 offset-xl-3">
          <p style={{ fontSize: "14px", color: "#6c757d", fontStyle: "italic", lineHeight: "1.6" }}>
            <strong style={{ fontSize: "16px", color: "#343a40" }}>Coupon Form Instructions:</strong> 
            This form allows you to create or update a coupon. You can specify the coupon's discount type (percentage or fixed amount), 
            value, duration, and maximum redemptions. If the coupon is set to repeat, you can define how many months it will last. 
            Once the coupon is created or updated, it will be saved for future use.
          </p>
        </div>
      </div>

      {/* Coupon Code */}
      <div className="form-group row">
        <label className="col-xl-3 col-lg-3 col-form-label">Coupon Name</label>
        <div className="col-lg-9 col-xl-6">
          <input
            type="text"
            className="form-control form-control-lg form-control-solid"
            value={coupon.couponName}
            onChange={(e) => setCoupon({ ...coupon, couponName: e.target.value })}
          />
          {errors?.couponName && <small className="text-danger">{errors.couponName}</small>}
        </div>
      </div>

      {/* Discount Type */}
      <div className="form-group row">
        <label className="col-xl-3 col-lg-3 col-form-label">Discount Type</label>
        <div className="col-lg-9 col-xl-6">
          <select
            className="form-control form-control-lg form-control-solid"
            value={coupon.discountType}
            onChange={(e) => setCoupon({ ...coupon, discountType: e.target.value })}
          >
            <option value="percent_off">Percentage</option>
            <option value="amount_off">Fixed Amount</option>
          </select>
        </div>
      </div>

      {/* Discount Value */}
      <div className="form-group row">
        <label className="col-xl-3 col-lg-3 col-form-label">Discount Value</label>
        <div className="col-lg-9 col-xl-6">
          <input
            type="number"
            className="form-control form-control-lg form-control-solid"
            value={coupon.discountValue}
            onChange={(e) => setCoupon({ ...coupon, discountValue: Number(e.target.value) })}
          />
          {errors?.discountValue && <small className="text-danger">{errors.discountValue}</small>}
        </div>
      </div>

      {/* Duration */}
      <div className="form-group row">
        <label className="col-xl-3 col-lg-3 col-form-label">Duration</label>
        <div className="col-lg-9 col-xl-6">
          <select
            className="form-control form-control-lg form-control-solid"
            value={coupon.duration}
            onChange={(e) => setCoupon({ ...coupon, duration: e.target.value })}
          >
            <option value="once">Once</option>
            <option value="repeating">Repeating</option>
            <option value="forever">Sponsored</option>
          </select>
          {errors?.duration && <small className="text-danger">{errors.duration}</small>}
        </div>
      </div>

      {/* Duration in Months */}
      {coupon.duration === "repeating" && (
        <div className="form-group row">
          <label className="col-xl-3 col-lg-3 col-form-label">Duration (Months)</label>
          <div className="col-lg-9 col-xl-6">
            <input
              type="number"
              className="form-control form-control-lg form-control-solid"
              value={coupon.durationInMonths}
              onChange={(e) =>
                setCoupon({ ...coupon, durationInMonths: Number(e.target.value) })
              }
            />
            {errors?.durationInMonths && (
              <small className="text-danger">{errors.durationInMonths}</small>
            )}
          </div>
        </div>
      )}

      {/* Display Uploaded Image */}
      {image && (
        <div className="form-group row justify-content-center">
          <img
            src={image.type ? URL.createObjectURL(image) : image}
            style={{ height: "100px", width: "100px", objectFit: "cover" }}
            alt="Coupon Icon"
          />
        </div>
      )}
      {errors?.image && (
        <div className="form-group row justify-content-center">
          <small className="text-danger">{errors.image}</small>
        </div>
      )}

      {/* Submit Button */}
      <div className="d-flex align-items-center justify-content-center">
        {submitValue ? (
          <button onClick={handleUpdateProduct} className="btn btn-success mr-2">
            <span>Update Coupon</span>
            {loading && <span className="mx-3 spinner spinner-white"></span>}
          </button>
        ) : (
          <button onClick={submitProduct} className="btn btnColor mr-2">
            <span>Add Coupon</span>
            {loading && <span className="mx-3 spinner spinner-white"></span>}
          </button>
        )}
      </div>
    </div>
  ) : null}
</List>





      </Dialog>
    </>
  );
};

export default Coupen;
